import { useGlobalState } from './GlobalStateContext';
import { storeAdminImpl } from './storeAdminImpl'; // the core logic

export function useStoreAdmin() {
  const { setJWT, setServerVersion, setInvoicesExpired, setPendingAuth, setPendingGuests, setGuests, setNotifications, setShowPropertiesSelector,  setMenu, setGData} = useGlobalState();

  return (data: any) => storeAdminImpl(data, setJWT, setServerVersion, setInvoicesExpired, setPendingAuth, setPendingGuests, setGuests, setNotifications, setShowPropertiesSelector, setMenu, setGData);
}
